import type { OpeningHour } from './opening-hour';
import { getRestaurantOpeningHourDayOfWeek } from './opening-hour-status.util';

function toTimeInputValue(time: string): string {
  return time.length >= 5 ? time.slice(0, 5) : time;
}

export function getOpeningHourSlotsForDay(
  openingHours: readonly OpeningHour[],
  dayOfWeek: number
): readonly string[] | null {
  const openSlots = openingHours.filter(
    (openingHour) => openingHour.dayOfWeek === dayOfWeek && openingHour.isOpen
  );

  if (openSlots.length === 0) {
    return null;
  }

  return openSlots.map(
    (openingHour) => `${toTimeInputValue(openingHour.from)}-${toTimeInputValue(openingHour.to)}`
  );
}

export function formatOpeningHoursForDay(
  openingHours: readonly OpeningHour[],
  dayOfWeek: number
): string | null {
  const timeSlots = getOpeningHourSlotsForDay(openingHours, dayOfWeek);

  if (!timeSlots) {
    return null;
  }

  return timeSlots.join(', ');
}

export function formatOpeningHoursForDate(
  openingHours: readonly OpeningHour[],
  date: Date
): string | null {
  if (openingHours.length === 0) {
    return null;
  }

  return formatOpeningHoursForDay(
    openingHours,
    getRestaurantOpeningHourDayOfWeek(openingHours, date)
  );
}
